/* eslint-disable import/no-extraneous-dependencies */
import { makeStyles } from '@mui/styles';

export default makeStyles(() => ({
}));
